import { useCallback } from 'react';
import { LOGIN_PATH } from './constants';

/**
 * Gets a full login URL for redirection (/corp/login if spoofed, /login otherwise).
 * @param redirectUrl The pathname to redirect to after login. Defaults to the current pathname. Empty if null.
 * @returns A string redirect URL.
 */
export function getLoginUrl(redirectUrl?: string | null) {
  if (redirectUrl === undefined) {
    redirectUrl = location.pathname + location.search;
  }
  if (!redirectUrl) {
    return LOGIN_PATH;
  }
  // Clean the search params (mandatory)
  const searchParams = new URLSearchParams();
  if (redirectUrl) {
    searchParams.append('redirect_url', redirectUrl);
  }
  return `${LOGIN_PATH}?${searchParams}`;
}

/**
 * Hook to get a redirect function that returns the user to the login page.
 * Have to use location.replace since /login is a top-level pathname.
 * @param redirectUrl The pathname to redirect to after login. Defaults to the current pathname. Empty if null.
 * @returns A function that redirects to the login page.
 */
export function useLoginRedirect(redirectUrl?: string | null) {
  const redirect = useCallback(() => location.replace(getLoginUrl(redirectUrl)), [redirectUrl]);
  return redirect;
}
